import React, { useState } from "react";
import { login,checkSession } from "../../services/Admin";
import "../Main.css";
import "./AdminLogin.css";
import { useEffect } from "react";
import axios from "axios";

const AdminLogin = () => {
    const image = { logo: require("../../images/marklogo.png") };
    let [id, setId] = useState("");
    let [password, setPassword] = useState("");

    useEffect(() => {
        axios
        .get(`/api/session`)
        .then((res) => {
            if(res.data === 200) {
                window.location.href = `/admin`;
            }
        })
    },[])

    const checkInputValue = () => {
        if (id === "") {
            alert("아이디를 입력해주세요");
        } else if (password === "") {
            alert("닉네임을 입력해주세요");
        } else {
            login(id, password).then((res) => {
                if (res.status === 200) {
                    window.location.href = `/admin`;
                } else {
                    alert("아이디 또는 비밀번호가 일치하지 않습니다.");
                }
            });
        }
    };

    const handleOnKeyPress = (e) => {
        if (e.key === "Enter") {
            checkInputValue();
        }
    };

    const handleHomeClick = () =>{
        window.location.href = `/`;
    }

    return (
        <div className="main-container">
            <div className="login-container">
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        paddingTop: "70px",
                        paddingBottom: "30px",
                    }}
                >
                    <div>
                        <img src={image.logo} style={{cursor:"pointer"}} width={200} onClick={handleHomeClick}></img>
                    </div>
                </div>
                <div className="login-input-container">
                    <div className="login-label">ID</div>
                    <input
                        className="login-input"
                        type="text"
                        placeholder="id를 입력해주세요"
                        value={id}
                        onChange={(e) => setId(e.target.value)}
                    />
                </div>

                <div className="login-input-container">
                    <div className="login-label">PW</div>
                    <input
                        className="login-input"
                        type="password"
                        placeholder="비밀번호를 입력해주세요"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyPress={handleOnKeyPress}
                    />
                </div>

                <div className="login-button" onClick={checkInputValue}>
                    Login
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
